goog.provide("shadow.js.shim.module$$restart$ui$Modal$default");
shadow.js.shim.module$$restart$ui$Modal$default = shadow.js.require(73, {}).default;
